import { roundNumberToDecimals } from '../../app-actions';
import { UPDATE_PRODUCT_RECOMMENDATION } from '../../app-constants';

// Compute Total Benfits - stripping out precision to 2
export const getTotalBenefits = productRecommendation => roundNumberToDecimals((productRecommendation.filter(
  productData => productData.recommendationSelected)
  .reduce((sum, productData) => sum + productData.optimizationPercentage, 0)));

export const updateProductRecommendation = productData => (dispatch) => {
  const { checkBoxState } = productData;
  dispatch({ type: UPDATE_PRODUCT_RECOMMENDATION, checkBoxState });
};
